import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { withTranslation } from 'react-i18next';
import routes, { renderRoutes } from './routes';
import { store } from './redux/store';
import JwtProvider from 'components/authentication/JwtProvider';
import { AuthService } from 'services/auth/auth';
import { IUser } from 'core/interface/user';
import { isAuthorized } from 'utils/isAuthorized';
import NotistackProvider from 'components/NotistackProvider';

import './App.scss';

function App({ tReady }: { tReady?: boolean }) {
  const [newUserData, setNewUserData] = useState<IUser | null>(null);
  const isAuth = isAuthorized();

  useEffect(() => {
    if (isAuth) {
      getAccount();
    }
  }, [isAuth]);

  const getAccount = async () => {
    AuthService.getAccount();
  };

  useEffect(() => {
    store.subscribe(() => {
      setNewUserData(store.getState()?.user?.user);
    });
  }, [store]);

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <HelmetProvider>
      {/*  eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ReduxProvider store={store}>
        {/*  eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        {tReady ? (
          <NotistackProvider>
            <JwtProvider>{renderRoutes(routes, newUserData)}</JwtProvider>
          </NotistackProvider>
        ) : (
          <></>
        )}
      </ReduxProvider>
    </HelmetProvider>
  );
}
export default withTranslation()(App);
